// 权限有关的指令
// 必须包含该权限码，元素才显示
export const auth = {
    install(Vue) {
        Vue.directive('auth', {
            bind: function (el, binding, vnode) {
                let flag = vnode.context.$store.getters.authMap[binding.value] ? true : false
                vnode.context.$nextTick(() => {
                    if (!flag) {
                        if (!el.parentNode) {
                            el.style.display = 'none';
                        } else {
                            el.parentNode.removeChild(el);
                        }
                    }
                })
            }
        });
    }
};
//  只要包含列出的任意一个权限码，元素就会显示
export const anyAuth = {
    install(Vue) {
        Vue.directive('anyAuth', {
            bind(el, binding, vnode) {
                const permissions = vnode.context.$store.getters.permissions;
                const value = binding.value;
                let flag = false;
                for (const v of value) {
                    if (permissions.includes(v)) {
                        flag = true;
                    }
                }
                vnode.context.$nextTick(() => {
                    if (!flag) {
                        if (!el.parentNode) {
                            el.style.display = 'none';
                        } else {
                            el.parentNode.removeChild(el);
                        }
                    }
                })
            }
        });
    }
};
